
import { useState, useEffect } from 'react';
import { X} from "lucide-react";
import showIcon from '../../../assets/hideIcon.png';
import closeIcon from '../../../assets/showIcon.png';
import '../../../styles/globalStyle.css';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
 import { message } from '../../messages/Message';
 import toast from "react-hot-toast";
import { deleteProfilePicture, uploadProfile } from '../../services/operations/profileAPI';
import Loader from '../../Loader/Loader'
import ChangePassword from './ChangePassword';

const AccountSetting = ({ isOpen, onClose }) => {
    const user = useSelector((state) => state.profile.user);
    const token = useSelector((state) => state.auth.token);
    const loading=useSelector((state)=>state.auth.loading)
    const dispatch = useDispatch();
    const MAX_FILE_SIZE = 2 * 1024 * 1024; 

    const { register, handleSubmit, watch, formState: { errors } } = useForm({
        defaultValues: {
            Name: user.name,
            Email: user.email
        }
    });

    const [selectedFile, setSelectedFile] = useState(null);
    const [previewSource, setPreviewSource] = useState(null)
    const [isChanged, setIsChanged] = useState(true);
    const [isEmailVisible, setIsEmailVisible] = useState(false);
    const [isPassword, setIsPassword] = useState(false);

    const toggleEmailVisibility = () => {
        setIsEmailVisible(!isEmailVisible);
    };

    const maskEmail = (email) => {
        const [name, domain] = email.split('@');
        return `${name.slice(0, 2)}*****@${domain}`;
    };

    const handlePictureChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > MAX_FILE_SIZE) {
                toast.error(message.profilePictureLimitMessage);
                return; 
            }
            setSelectedFile(file);
            previewFile(file);
        }
    };

    const previewFile = (file) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = () => {
            setPreviewSource(reader.result)
        }
    }
    useEffect(() => {
        if (selectedFile) {
            previewFile(selectedFile)
        }
    }, [selectedFile])


    const watchedName = watch("Name");

    useEffect(() => {
        if (watchedName !== user.name || selectedFile) {
            setIsChanged(true);
        } else {
            setIsChanged(false);
        }
    }, [watchedName, selectedFile, user.name]);

    const handleDeletePicture = () => {
        dispatch(deleteProfilePicture(token));
    };

    const handleOpenPasswordChange = () => {
        setIsPassword(true)
    }
    const handleClosePasswordChange = () => {
        setIsPassword(false);
    }

    const onSubmit = (data) => {
        const { Name } = data;
        const formData = new FormData()
        if (selectedFile) {
            formData.append("profile_image", selectedFile);
        }
        
        formData.append('name', Name)
        dispatch(uploadProfile(token, formData, onClose))
        
    };

    return (
        <div className="profile-account-overlay">
            {loading && <Loader/>}
            <div className="profile-account-content">
                <div className='profile-account-heading'>
                    <p style={{ fontWeight: "600", fontSize: "26px" }}>Profile Settings</p>
                    <X className="close-icon" onClick={onClose} />
                </div>
                
                <form className="profile-edit-user-form" onSubmit={handleSubmit(onSubmit)}>
                    <div className='profile-picture-heading'>Profile Picture</div>
                    <div className="profile-image-section">
                        <img
                            src={previewSource || user?.profile_image}
                            alt="preview"
                            className="profile-picture"
                        />

                        <div className="image-buttons">
                            <label className="change-picture-btn">
                                Change Picture
                                <input
                                    type="file"
                                    accept="image/png, image/gif, image/svg,image/jpeg"
                                    style={{ display: 'none' }}
                                     onChange={handlePictureChange}
                                />
                            </label>
                            <button
                                type="button"
                                className="delete-picture-btn"
                                onClick={handleDeletePicture}
                            >
                                Delete Picture
                            </button>
                        </div>
                    </div>
                    <div className="profile-form-type">
                        <label htmlFor="name">Name</label>
                        <input
                            type="text"
                            id="Name"
                            maxLength={20}
                            name="Name"
                            className="profile-form-input-account"
                            {...register("Name", {
                                required: "Name is required",
                                pattern: {
                                    value: /^[A-Za-z\s]+$/,
                                    message: "Name must contain only alphabets and spaces"
                                }
                            })}
                        />
                         {errors.Name && <p className="error-message" style={{margin:"3px 0px 0px 0px"}}>{errors.Name.message}</p>}
                    </div>
                    <div className="profile-form-type">
                        <label htmlFor="Company">Company Name</label>
                        <input
                            type="text"
                            id="Company"
                            maxLength={20}
                            name="Company"
                            readOnly
                            className="profile-form-input-account"
                            value={user?.business?.company_name}
                        />
                    </div>
                    <div className="profile-form-type">
                        <label htmlFor="email">Email Id</label>
                        <input
                            type="text"
                            id="Email"
                            name="Email"
                            readOnly
                            className="profile-form-input-account"
                            value={isEmailVisible ? user.email : maskEmail(user.email)}
                        />
                        <span className='password-show-email'>
                            <img
                                src={isEmailVisible ? showIcon : closeIcon}
                                alt={isEmailVisible ? 'Hide Email' : 'Show Email'}
                                className="toggle-icon"
                                onClick={toggleEmailVisibility}
                            />
                        </span>
                    </div>
                    <div className="profile-form-type">
                        <label htmlFor="name">Password</label>
                    </div>
                    <button
                        type="button"
                        className="change-password-btn"
                         onClick={handleOpenPasswordChange}
                    >
                        Change Password
                    </button>
                    <button
                        type="submit"
                        className="profile-save-button"
                        disabled={!isChanged}
                    >
                        Save Changes
                    </button>
                </form>
            </div>
         {isPassword && <ChangePassword onClose={handleClosePasswordChange} isOpen={handleOpenPasswordChange} />}
        </div>
    );
};

export default AccountSetting;
